"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginationMetaDto = instanceOfPaginationMetaDto;
exports.PaginationMetaDtoFromJSON = PaginationMetaDtoFromJSON;
exports.PaginationMetaDtoFromJSONTyped = PaginationMetaDtoFromJSONTyped;
exports.PaginationMetaDtoToJSON = PaginationMetaDtoToJSON;
exports.PaginationMetaDtoToJSONTyped = PaginationMetaDtoToJSONTyped;
/**
 * Check if a given object implements the PaginationMetaDto interface.
 */
function instanceOfPaginationMetaDto(value) {
    if (!('currentPage' in value) || value['currentPage'] === undefined)
        return false;
    if (!('previousPage' in value) || value['previousPage'] === undefined)
        return false;
    if (!('nextPage' in value) || value['nextPage'] === undefined)
        return false;
    return true;
}
function PaginationMetaDtoFromJSON(json) {
    return PaginationMetaDtoFromJSONTyped(json, false);
}
function PaginationMetaDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'],
        'previousPage': json['previousPage'],
        'nextPage': json['nextPage'],
        'isFirstPage': json['isFirstPage'] == null ? undefined : json['isFirstPage'],
        'isLastPage': json['isLastPage'] == null ? undefined : json['isLastPage'],
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
        'pageCount': json['pageCount'] == null ? undefined : json['pageCount'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'startCursor': json['startCursor'] == null ? undefined : json['startCursor'],
        'endCursor': json['endCursor'] == null ? undefined : json['endCursor'],
    };
}
function PaginationMetaDtoToJSON(json) {
    return PaginationMetaDtoToJSONTyped(json, false);
}
function PaginationMetaDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'previousPage': value['previousPage'],
        'nextPage': value['nextPage'],
        'isFirstPage': value['isFirstPage'],
        'isLastPage': value['isLastPage'],
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
        'pageCount': value['pageCount'],
        'totalCount': value['totalCount'],
        'startCursor': value['startCursor'],
        'endCursor': value['endCursor'],
    };
}
//# sourceMappingURL=PaginationMetaDto.js.map